import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import TabBar from '../../components/layout/TabBar';
import Home from './home';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Payments from './payments';
import Profile from './profile';
import QRRedirect from './qr-redirect';

const MainPage = () => {
  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const currentTab = pathParts[2] || 'home';

  return (
    <>
      <Flex justify="center" flex={1} mt={20} px={2}>
        <Box w="full">
          <Routes>
            <Route path="/" element={<Navigate to="/main/home" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/payments/qr/:encodedValue" element={<QRRedirect />} />
            <Route path="/payments/*" element={<Payments />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/not-found" element={<Box p={4}>ページが見つかりません。</Box>} />
          </Routes>
        </Box>
      </Flex>
      <TabBar selectedTab={currentTab} />
    </>
  );
};

export default MainPage;
